import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewSearch from "@/pages/NewSearch";
import SearchHistory from "@/pages/SearchHistory";
import SearchDetail from "@/pages/SearchDetail";
import Prospects from "@/pages/Prospects";
import Imports from "@/pages/Imports";
import Exports from "@/pages/Exports";
import Settings from "@/pages/Settings";
import Appearance from "@/pages/Appearance";
import AIModels from "@/pages/AIModels";
import CampaignStudio from "@/pages/CampaignStudio";
import LandingPages from "@/pages/LandingPages";
import BuyerLeads from "@/pages/BuyerLeads";
import LeadIntelligence from "@/pages/LeadIntelligence";
import CompetitorAds from "@/pages/CompetitorAds";
import Integrations from "@/pages/Integrations";
import PublicLandingPage from "@/pages/PublicLandingPage";
import Research from "@/pages/Research";
import LandingStudio from "@/pages/LandingStudio";
import AdEvidence from "@/pages/AdEvidence";
import NewsIntelligence from "@/pages/NewsIntelligence";
import NewsWhatsApp from "@/pages/NewsWhatsApp";
import ProfessionalDiscovery from "@/pages/ProfessionalDiscovery";
import Accounts from "@/pages/Accounts";
import ProfessionalSearchHistory from "@/pages/ProfessionalSearchHistory";
import SetupCentre from "@/pages/SetupCentre";

function Protected({ children, adminOnly = false }) {
  const { admin } = useAuth();
  if (admin === null) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading…</div>;
  if (!admin) return <Navigate to="/login" replace />;
  if (adminOnly && admin.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/p/:slug" element={<PublicLandingPage />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/search/new" element={<NewSearch />} />
              <Route path="/research" element={<Research />} />
              <Route path="/searches" element={<SearchHistory />} />
              <Route path="/searches/:id" element={<SearchDetail />} />
              <Route path="/prospects" element={<Prospects />} />
              <Route path="/shortlist" element={<Prospects shortlistOnly />} />
              <Route path="/imports" element={<Imports />} />
              <Route path="/exports" element={<Exports />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/appearance" element={<Appearance />} />
              <Route path="/ai-models" element={<AIModels />} />
              <Route path="/campaign-studio" element={<CampaignStudio />} />
              <Route path="/landing-pages" element={<LandingStudio />} />
              <Route path="/buyer-leads" element={<BuyerLeads />} />
              <Route path="/lead-intelligence" element={<LeadIntelligence />} />
              <Route path="/competitor-ads" element={<AdEvidence />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/setup" element={<SetupCentre />} />
              <Route path="/news-intelligence" element={<NewsIntelligence />} />
              <Route path="/news-whatsapp" element={<NewsWhatsApp />} />
              <Route path="/professional-discovery" element={<ProfessionalDiscovery />} />
              <Route path="/professional-searches" element={<ProfessionalSearchHistory />} />
              <Route path="/accounts" element={<Protected adminOnly><Accounts /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
